import { ref } from "vue";
import global from "@/global";

export function useFetch({ uri, headers, skipAutoFetch = true }) {
  const fetchedData = ref(null);
  const fetchError = ref(null);

  const fetchData = async () => {
    try {
      const res = await fetch(`${global.API_URL}${uri}`, {
        method: "GET",
        headers: headers,
      });

      fetchedData.value = await res.json();
    } catch (err) {
      fetchError.value = err;
    }
  };

  !skipAutoFetch && fetchData();

  return { fetchData, fetchedData, fetchError };
}
